import { reduxBatch } from '@manaflair/redux-batch';
import createSagaMiddleware from '@redux-saga/core';
import throttle from 'lodash.throttle';
import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import {
  default as auth,
  initialState as initialAuthState,
} from 'store/Auth/slice';
import {
  default as directPosts,
  initialState as initialDirectPostsState,
} from 'store/DirectPosts/slice';
import rootSaga from 'store/sagas';
import {
  default as tokenTeam,
  initialState as initialTokenTeamState,
} from 'store/TokenTeam/slice';
import { loadState, saveState } from './storage';

const persistedState = loadState();

const sagaMiddleware = createSagaMiddleware();

const defaultState = {
  auth: initialAuthState,
  tokenTeam: initialTokenTeamState,
  directPosts: initialDirectPostsState,
};

const store = configureStore({
  reducer: {
    auth,
    tokenTeam,
    directPosts,
  },
  middleware: [sagaMiddleware, ...getDefaultMiddleware()],
  devTools:
    process.env.NEXT_PUBLIC_API_BASE_URL !==
    'https://api.getdelta.io/token-dashboard',
  preloadedState: persistedState || defaultState,
  enhancers: [reduxBatch],
});

sagaMiddleware.run(rootSaga);

store.subscribe(
  throttle(() => {
    saveState({
      auth: store.getState().auth,
      tokenTeam: store.getState().tokenTeam,
      directPosts: store.getState().directPosts,
    });
  }, 1000),
);

export default store;
